import { render, staticRenderFns } from "./LabelListTableAction.vue?vue&type=template&id=2787c039&scoped=true"
import script from "./LabelListTableAction.vue?vue&type=script&lang=js"
export * from "./LabelListTableAction.vue?vue&type=script&lang=js"
import style0 from "./LabelListTableAction.vue?vue&type=style&index=0&id=2787c039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2787c039",
  null
  
)

export default component.exports